var exports = {
  "open": "open__f4JSZn",
  "done": "done__sTzkSN",
  "danger": "danger__0AMG5U",
  "AvatarWithBadge": "AvatarWithBadge__FB-87K",
  "AvatarBadge": "AvatarBadge___IEZKw",
  "solidBackground": "solidBackground__YX1kFZ",
};

__webpack_require__.r(module.exports = exports);
